import { render } from "./EventManageView.vue?vue&type=template&id=10806d6c&scoped=true"
import script from "./EventManageView.vue?vue&type=script&lang=js"
export * from "./EventManageView.vue?vue&type=script&lang=js"

import "./EventManageView.vue?vue&type=style&index=0&id=10806d6c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10806d6c"]])

export default __exports__